import React from 'react'
import CloseIcon from '@mui/icons-material/HighlightOff'
import { Alert, IconButton, Snackbar } from '@mui/material'

interface ErrorSnackbarProps {
  setErrorSnackbarOpen: (value: boolean) => void
  isErrorSnackbarOpen: boolean
  message: string
}

export default function ErrorSnackbar({
  setErrorSnackbarOpen,
  isErrorSnackbarOpen,
  message
}: ErrorSnackbarProps) {
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return
    }
    setErrorSnackbarOpen(false)
  }
  const action = (
    <>
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={handleClose}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </>
  )

  return (
    <Snackbar
      open={isErrorSnackbarOpen}
      onClose={handleClose}
      action={action}
      autoHideDuration={6000}
      sx={{ width: '100%', justifyContent: 'center' }}
    >
      <Alert onClose={handleClose} severity='error'>
        {message}
      </Alert>
    </Snackbar>
  )
}
